export default __webpack_public_path__ + "static/competish-iphone-mockup-2-e819755ac5958b54504e484ca71e3698.png";